import styled from '@emotion/styled';

export const Card = styled.div`
  width: 100%;
  min-height: 17rem;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 1.3rem;
  background-color: ${({ theme }) => theme.colors.white};
  & * {
    text-align: center !important;
  }

  ${({ theme }) => theme.media.tablet} {
    padding: 1.5rem 3rem;
  }

  @media (max-width: 800px) {
    padding: 1.5rem;
  }
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
